import { PatientMedicine } from '@dreryk/egabinet-prescription-frontend-api';
import { Patient } from '@dreryk/egabinet-patient-frontend-api';

import { FormController } from '@dreryk/react-components';
import { FormContextValues } from '@dreryk/react-common';

import { VisitDiagnoses } from '~libs.shared.visit';

import { NewMedicineFieldFormBeanPart } from './NewMedicineField.types';
import { NewMedicineView } from './view/NewMedicineView';
import { MedicineSelector } from './selector/MedicineSelector';

type NewMedicineFieldProps = Pick<
   FormContextValues<NewMedicineFieldFormBeanPart>,
   'register' | 'control' | 'setValue'
> & {
   patientId: Patient['id'];
   withdrawnMedicineId: number;
   visitDiagnoses: VisitDiagnoses;
};

export const NewMedicineField = (props: NewMedicineFieldProps): JSX.Element => {
   return (
      <FormController<PatientMedicine | null>
         controller={props.register('newMedicine', {
            required: true,
         })}
      >
         {({ value: patientMedicine }) => {
            if (patientMedicine) {
               return (
                  <NewMedicineView
                     patientMedicine={patientMedicine}
                     visitDiagnoses={props.visitDiagnoses}
                     setValue={props.setValue}
                  />
               );
            }

            return (
               <MedicineSelector
                  register={props.register}
                  control={props.control}
                  setValue={props.setValue}
                  patientId={props.patientId}
                  visitDiagnoses={props.visitDiagnoses}
                  withdrawnMedicineId={props.withdrawnMedicineId}
               />
            );
         }}
      </FormController>
   );
};
